enum PatternFillType {
    None,
    FallingDiagonal,
    ClimbingDiagonal,
    Vertical,
    Horizontal,
    StrangeS,
    Squares,
    Circles,
    StrangeZ,
    Diamonds,
    Waves,
}

export default PatternFillType;
